import { Breakpoints, CTA, Layout, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { LoginErrorPageViewProps } from './LoginErrorPageViewProps';

const StyledHeadline = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.dynamic0150};
`;
const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.dynamic0250};
`;

export function LoginErrorPageVwView({ onClick }: LoginErrorPageViewProps): ReactElement {
  return (
    <Layout allowOverflowingContent>
      <Text appearance={TokenTextAppearance.headline400}>We could not find</Text>
      <StyledHeadline appearance={TokenTextAppearance.headline400} bold>
        your vehicle details
      </StyledHeadline>
      <StyledText appearance={TokenTextAppearance.copy200}>You can try using another vehicle identification option.</StyledText>
      <CTA
        tag="button"
        size="large"
        onClick={onClick}
        stretchContent={{
          [Breakpoints.default]: true,
          [Breakpoints.b560]: false,
        }}>
        Try again
      </CTA>
    </Layout>
  );
}
